/* API Base and EndPoints */

let baseUrl = process.env.REACT_APP_BASEURL;
const baseEndPointString = process.env.REACT_APP_BASE_ENDPOINT || "";

/* Service APIs */
const user: any = {
  create: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/user",
  },
  createUser: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/user/create",
  },
  get: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/user",
  },
  updateAccount: {
    method: "PATCH",
    baseEndPoint: baseEndPointString,
    endPoint: "/user/updateaccount",
  },
  changePassword: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/user/changepassword",
  },
  forgotPassword: {
    method: "PATCH",
    baseEndPoint: baseEndPointString,
    endPoint: "/user/forgotpassword",
  },
  checkvieweraccess: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/user/checkvieweraccess",
  },
  viewerLogin: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/user/viewer_login",
  },
  //Duplicate APIS
  isShowPublisher: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/user",
  },
  identify: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/user/identify",
  },
};

const otp: any = {
  googleAuth2FA: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/otp/googleAuth",
  },
  validateGoogleAuth2FA: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/otp/googleAuthValidate",
  },
  disableGoogleAuth2FA: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/otp/disableOTPAuthStatus",
  },
  requestOTP: {
    method: "PATCH",
    baseEndPoint: baseEndPointString,
    endPoint: "/otp/requestOtp",
  },
  validateOTP: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/otp/validateOtp",
  },
  disable2FAClaims:{
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/otp/disable2FAClaims",
  }
}

const stripe: any = {
  createSetupIntent: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/createSetupIntent",
  },
  listStripePaymentMethods: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/listPaymentMethods",
  },
  getPricingDetails: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/price",
  },
  createSubscription: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/createSubscription",
  },
  cancelSubscription: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/cancelSubscription",
  },
  reActivateSubscription: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/reActivateSubscription",
  },
  retrieveSubscription: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/retrieveSubscription",
  },
  upgradeSubscription: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/upgradeSubscription"
  },
  detachPayment: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/detachPayment",
  },
  getInvoiceDetails: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/stripe/getCustomerInvoice",
  },
};
const payment_method: any = {
  createPaymentMethod: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/payment_method",
  },
};
const old: any = {
  remove: {},
  subscribeStream: {}

}
const room: any = {
  getRoom: {
    method: 'GET',
    baseEndPoint: baseEndPointString,
    endPoint: "/room",
  },
  createRoom: {
    method: 'PATCH',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/addStreamToRoom",
  },
  updateRoom: {
    method: 'PATCH',
    baseEndPoint: baseEndPointString,
    endPoint: "/room",
  },
  updateAutoAllowRoom: {
    method: 'PATCH',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/auto_allow",
  },
  updateRoomByViewer: {
    method: 'PATCH',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/update/viewer",
  },
  removeRoomByViewer: {
    method: 'PATCH',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/remove/viewer",
  },
  getAllRoomsOfUser: {
    method: 'GET',
    baseEndPoint: baseEndPointString,
    endPoint: "/room",
  },
  getAllActiveRoomsOfUser: {
    method: 'GET',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/active",
  },
  refreshCode: {
    method: 'POST',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/refresh_code",
  },
  deleteSession: {
    method: 'DELETE',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/delete_session",
  },
  deleteRoom: {
    method: 'DELETE',
    baseEndPoint: baseEndPointString,
    endPoint: "/room",
  },
  getPublishTokens: {
    method: 'POST',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/get_publish_tokens",
  },
  getPublishToken: {
    method: 'GETs',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/publishtoken",
  },
  subscribeStream: {
    method: 'POST',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/subscribe_stream",
  },
  getTwilioVideoToken: {
    method: 'GET',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/twilio/video/token",
  },
  getTwilioRoomsParticipants: {
    method: 'GET',
    baseEndPoint: baseEndPointString,
    endPoint: "/room/twilio/getTwilioRoomsParticipants",
  },
  getValidRoom: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/room/valid",
  },
  autoAllow: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/room/allow",
  },
  getGuestList: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/room/guest",
  },
  updateGuestStatus: {
    method: "PATCH",
    baseEndPoint: baseEndPointString,
    endPoint: "/room/guest",
  },
  clearWaitingRoom: {
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/room/clear_waiting",
  },
  addFreeRoom:{
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/room/add_free_room",
  },
  leaveOrEndConference:{
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/room/leaveOrEndConference",
  },
  generateZoomVideoSDKJWT:{
    method: "POST",
    baseEndPoint: baseEndPointString,
    endPoint: "/room/generate_zoom_video_sdk_jwt",
  }
}

const featureFlags = {
  listAllFlags: {
    method: "GET",
    baseEndPoint: baseEndPointString,
    endPoint: "/featureflags",
  }
};

const zoom = {
  generateVideoSDKJWT: {
      method: "POST",
      baseEndPoint: baseEndPointString,
      endPoint: "/room//generate_zoom_video_sdk_jwt",
  },
};

const api = { baseUrl, user, stripe, payment_method, room, old, otp, featureFlags, zoom };

export default api;
